import { isMobile } from './utilities'
const TimelineLite = window.TimelineLite;
const Linear = window.Linear;

const preloadedImages = {};

const loadImage = ( url, callback) => {
  //console.log( 'load: ' + url );
  var img = document.createElement( 'img' );
  img.onload = () => {
    preloadedImages[ url ] = true;
    callback();
  };
  img.src = url;
};

export default class {
  constructor( el ){
    this.el = el;

    let data;
    if( el.dataset ){
      data = el.dataset[ 'slides' + (isMobile() ? 'Mobile' : '') ];
    }else{
      data = el.getAttribute( 'data-slides' + (isMobile() ? '-mobile' : '') );
    }

    this.slidesUrls = JSON.parse(data);
    this.slideIndex = -1;
    this.currentSlide = null;

    this.__isVisible = false;

    document.addEventListener( 'scroll', this.checkVisibility.bind(this) );

    loadImage( this.slidesUrls[0], () => {
      this.currentSlide = this.addSlide( 0 );
      this.slideIndex = 0;
      this.checkVisibility();
    });
  }

  set isVisible ( v ) {
    if( v === this.__isVisible ){
      return;
    }
    this.__isVisible = v;
    if( v ){
      if( this.timeline ){
        this.timeline.resume();
      }else{
        this.showNextSlide();
      }
    }else{
      if( this.timeline ){
        this.timeline.pause();
      }
    }
  }

  get isVisible(){
    return this.__isVisible;
  }

  checkVisibility(){
    const rect = this.el.getBoundingClientRect();
    this.isVisible = (rect.top < window.innerHeight && rect.bottom > 0);
    //console.log( 'CHECK VISIBILITY: ' + this.isVisible );
  }

  addSlide( index ){
    const img = document.createElement( 'div' );
    img.className = 'slide';
    img.style.backgroundImage = 'url(' + this.slidesUrls[index] + ')';
    this.el.appendChild( img );
    return img;
  }

  showNextSlide() {
    if( !this.isVisible ){
      return;
    }
    const nextIndex = (this.slideIndex+1) % this.slidesUrls.length;
    const nextURL = this.slidesUrls[nextIndex];
    if( !preloadedImages[nextURL] ){
      loadImage( nextURL, this.showNextSlide.bind(this) );
    }else{
      const newSlide = this.addSlide( nextIndex );
      newSlide.style.opacity = 0;
      this.timeline = new TimelineLite({
        onComplete: () => {
          this.el.removeChild( this.currentSlide );
          this.currentSlide = newSlide;
          this.slideIndex = nextIndex;
          this.timeline = null;
          this.showNextSlide();
        }
      });
      this.timeline.to( this.currentSlide, 5, {
        scaleX:1.055, scaleY:1.055,
        ease: Linear.easeNone
      });
      this.timeline.to( newSlide, 0.5, {
        opacity: 1,
        scaleX:1.005, scaleY:1.005,
        ease: Linear.easeNone
      }, '-=0.5');


    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/js/SlideShow.js
 **/